import { Big } from 'big.js';
import { bigToString, Corridor, parseBig, ServiceLine } from 'quote-domain-core';
import { CorridorService } from './corridor/corridor-service';
import { singleton } from 'tsyringe';

@singleton()
export class ServiceLineService {
    constructor(private readonly corridorService: CorridorService) {
    }

    public updateAppliedPriceAndColor(serviceLine: ServiceLine): void {
        let appliedPrice = new Big(0);
        const globalCorridor = new Corridor();
        const newGlobalCorridor = serviceLine.newQuoteService?.globalCorridor;
        const renewalGlobalCorridor = serviceLine.renewalQuoteService?.globalCorridor;
        if (serviceLine.newQuoteService) {
            appliedPrice = parseBig(serviceLine.newQuoteService.appliedPrice);
            this.corridorService.addCorridor(globalCorridor, newGlobalCorridor);
        }
        if (serviceLine.renewalQuoteService) {
            appliedPrice = appliedPrice.plus(parseBig(serviceLine.renewalQuoteService.appliedPrice));
            this.corridorService.addCorridor(globalCorridor, renewalGlobalCorridor);
        }
        const definedCorridors = [newGlobalCorridor, renewalGlobalCorridor].filter(c => c != null);
        if (definedCorridors.length && definedCorridors.every(c => c.isNeutral === true)) {
            globalCorridor.isNeutral = true;
        }
        const color = this.corridorService.getMatchedColorByappliedPrice(globalCorridor, bigToString(appliedPrice), serviceLine.newQuoteService.nonNegociableArticleColor);
        Object.assign(serviceLine, { appliedPrice: bigToString(appliedPrice), appliedPriceColor: color });
    }
}
